module.exports = __webpack_public_path__ + "img/vi.2031b4d3.svg";